import type { DesignBlock, DesignElement } from '@/types/blocks'
import { createDesignElement, updateElementAt } from '@/features/editor/lib/designElements'
import { useBlockDraftContext } from '@/features/editor/components/studio/BlockDraftContext'
import { DesignElementSettings } from './design/DesignElementSettings'
import { ElementPalette } from './design/ElementPalette'
import { BlockButtonsEditor } from './shared/BlockButtonsEditor'

interface Props {
  block: DesignBlock
  onChange: (next: DesignBlock) => void
}

export const DesignBlockEditor = ({ block, onChange }: Props) => {
  const { selectedElementId, setSelectedElementId } = useBlockDraftContext()
  const selected = block.elements.find((el) => el.id === selectedElementId) ?? null

  if (selected) {
    return (
      <DesignElementSettings
        element={selected}
        onUpdate={(patch: Partial<DesignElement>) =>
          onChange({ ...block, elements: updateElementAt(block.elements, selected.id, patch) })
        }
        onClose={() => setSelectedElementId(null)}
      />
    )
  }

  return (
    <div className="space-y-4">
      <ElementPalette
        count={block.elements.length}
        onAdd={(type) => {
          const element = createDesignElement(type)
          onChange({ ...block, elements: [...block.elements, element] })
          setSelectedElementId(element.id)
        }}
      />
      <BlockButtonsEditor
        blockType={block.type}
        buttons={block.buttons}
        onChange={(buttons) => onChange({ ...block, buttons })}
      />
    </div>
  )
}
